import React, { useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import ZoneService from "../../../services/Zone";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { Alert, Snackbar } from "@mui/material";
import { useNavigate } from "react-router-dom";

const ZoneTable = ({ listZones }) => {
  const navigate = useNavigate()
  const [zones, setZones] = useState([]);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  useEffect(() => {
    console.log(listZones)
    setZones(listZones)
  }, [listZones])
  const { SearchBar } = Search;

  const columns = [
    {
      dataField: "id",
      text: "ID",
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "name",
      text: "Name",
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "description",
      text: "Description",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "30%" };
      },
    },
    // {
    //   dataField: "commercialList",
    //   text: "Responsable List",
    //   align: "center",
    //   headerAlign: "center",
    // },
    {
      dataField: "id",
      text: "Societe",
      formatter: (cell, row) => (

        <button
          className="btn btn-dark"
          onClick={() => handleSowSocietzeZone(row.id)}
        >
          <i className="fas fa-eye"></i>
        </button>


      ),
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "id",
      text: "Action",
      formatter: (cell, row) => (
        <div className="row gap-2 d-flex justify-content-center">
          <button
            className="btn btn-dark mr-1"
            onClick={() => handleEditZone(row.id)}
          >
            <i className="fas fa-edit"></i>
          </button>
          <button
            className="btn btn-danger ml-1"
            onClick={() => handleDeleteZone(row.id)}
          >
            <i className="fas fa-trash"></i>
          </button>
          <button
            className="btn btn-danger ml-1 mt-1"
            onClick={() => navigate(`/BSZone?id=${row.id}`)}
          >
            Bon De Sortie
          </button>
          <button
            className="btn btn-danger ml-1 mt-1"
            onClick={() => navigate(`/PlaningZone?id=${row.id}`)}
          >
            planing
          </button>
          <button
            className="btn btn-dark ml-1 mt-1"
            onClick={() => {
              navigate(`/Recap`)
              sessionStorage.setItem("zone", row.id);
            }}
          >
            Recap
          </button>
        </div>
      ),
      align: "center",
      headerAlign: "center",
    },
  ];
  const handleDeleteZone = async (id) => {
    try {
      // Make the API call to delete the zone
      const response = await ZoneService.deleteZone(id, 1);

      if (response.data.success) {
        // Update the state only after successful deletion
        setZones(zones.filter((zone) => zone.id !== id));

        // Notify the user about successful deletion
        setInfoAlertText("Zone deleted successfully.");
        setOpenInfoAlert(true);
      } else {
        // Handle unexpected responses from the server
        console.error("Deletion failed:", response.data.message || "Unknown error");
      }
    } catch (error) {
      // Log and handle any errors during the API call
      console.error("Error deleting zone:", error);
      setInfoAlertText("Failed to delete the zone. Please try again.");
      setOpenInfoAlert(true);
    }
  };
  const handleEditZone = async (id) => {
    navigate(`/updateZone?id=${id}`)
  }; 
  const handleSowSocietzeZone = (id) => {
    navigate(`/SocieteByZone?id=${id}`)
  }
  const handleInfoClose = () => {
    setOpenInfoAlert(false);
  };

  const options = {
    paginationSize: 5,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "10",
        value: 10,
      },
    ],
  };

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Zone</h3>
        <br/>
        <button
            className="btn btn-dark ml-1 mt-1"
            onClick={() => {
              navigate(`/RecapAllZones`)
            }}
          >
            Recap Tous les zones
          </button>
            <button
            className="btn btn-dark ml-1 mt-1"
            onClick={() => {
              navigate(`/PlanningAllZones`)
            }}
          >
            Planning Tous les zones
          </button>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="id"
          data={zones}
          columns={columns}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row mb-3">
                <div className="col">
                  <SearchBar
                    {...props.searchProps}
                    placeholder="Search zones..."
                  />
                </div>
              </div>
              <BootstrapTable
                {...props.baseProps}
                pagination={paginationFactory(options)}
                striped
                hover
                condensed
              />
            </div>
          )}
        </ToolkitProvider>
      </div>

      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}
    </div>
  );
};

export default ZoneTable;
